import React from 'react';

import Box  from '@mui/material/Box';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { faBars } from '@fortawesome/free-solid-svg-icons';

import { useResponsive } from 'handimap-react-lib/hooks/useResponsive';
import { setOpenSideBar } from 'handimap-react-lib/store/actions/sideBarActions';
import { FontAwesomeSvgIcon } from 'handimap-react-lib/components/FontAwesomeSvgIcon';
import { config } from 'handimap-react-lib/config';

export const SideBarContainer = ({open, children, showSidebarMobile}) => {
  const { isMobile  } = useResponsive();
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const renderMobileSideBar = () => {
    if (showSidebarMobile) {
      return (
        <Collapse 
          id='dialog-sidebar' 
          in={open}
          sx={styles.sideContainer}
          timeout={{
            enter: 1000,
            exit: 1000
          }}
          unmountOnExit
        >
          <Box sx={styles.mobileContainer}>
            {children}
          </Box>
        </Collapse>
      );
    } else {
      return (
        <Box sx={styles.openButtonContainer}>
          <Button 
            variant='contained'
            id='open-side-mobile' 
            aria-label={t('common.aria-open-side-mobile')} 
            sx={styles.buttonMenu} 
            startIcon={<FontAwesomeSvgIcon icon={faBars} />}
            onClick={() => dispatch(setOpenSideBar(true))}
          >
            <img 
              src={config.url.PUBLIC_URL + '/logo.png'}
              style={{width: '80%', height: '60%'}}
              alt=''
            />
          </Button>
        </Box>
      );
    }
  };
  
  const styles = {
    container : {
      display: open ? 'flex' : 'none',
      position: 'absolute',
      left: 0,
      backdropFilter: 'blur(8px)',
      width: '390px',
      backgroundColor: 'rgba(255, 255, 255, 0.8)',
      height: 'calc(100% - 44px)',
      zIndex: 100,
      flexDirection: 'column',
      overflowY: 'auto',
      '&:focus': {
        outline: 'none',
      },
      '&::-webkit-scrollbar': {
        width: '8px'
      }, 
      '&::-webkit-scrollbar-track': {
        width: '4px',
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: '0.5em',
        backgroundColor: 'gray'
      },
    },
    sideContainer: {
      zIndex: 1000,
      width: '100vw',
      position: 'absolute',
      backgroundColor: 'rgba(255, 255, 255, 0.8)'
    },
    mobileContainer: {
      display: 'flex',
      backdropFilter: 'blur(8px)',
      height: 'calc(100vh - 44px)',
      width: '100%',
      flexDirection: 'column',
      overflowY: 'auto',
      '&:focus': {
        outline: 'none',
      },
      '&::-webkit-scrollbar': {
        display: 'none'
      }, 
    },
    openButtonContainer: {
      display: open ? 'block' : 'none',
      position: 'absolute',
      left: 10,
      top: 50,
      zIndex: 100,
    },
    buttonMenu: {
      display: 'inline-flex',
      height: 55,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#FFFFFF',
      textTransform: 'none'
    }
  };
  return (
    <React.Fragment>
      {isMobile ? renderMobileSideBar() : (
        <Box sx={styles.container}>
          {children}
        </Box>
      )}
    </React.Fragment>
  );
};